import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useMarkSingleRead } from '@modules/notifications/hooks/use-mark-notification-read';
import { useMarkSingleAsSeen } from '@modules/notifications/hooks/use-mark-notification-seen';

export const useNotificationRedirection = () => {
  const navigate = useNavigate();

  const { markSingleReadHandler } = useMarkSingleRead(false);
  const { markAsSeenNotification } = useMarkSingleAsSeen();

  useEffect(() => {
    function onMessage(e: MessageEvent) {
      const { type, payload, notificationId } = e?.data ?? {};
      if (type === 'redirection') {
        navigate(payload);
        if (notificationId) {
          markSingleReadHandler(+notificationId, true);
          markAsSeenNotification({ variables: { notificationId: +notificationId } });
        }
      }
    }
    navigator?.serviceWorker?.addEventListener('message', onMessage);
    return () => {
      navigator.serviceWorker?.removeEventListener('message', onMessage);
    };
  }, []);
};
